




























import { Vue, Component } from 'vue-property-decorator';

import ConfirmModal from '@/components/modal/ConfirmModal.vue';
import IconRemove from '@/components/icons/Remove.vue';

import { ConsultationStatus } from '@/types/consultations'

@Component({
    components: {
        ConfirmModal,
        IconRemove,
    },
})
export default class ConsultationCancelActions extends Vue {
    open = false;
    confirmCancelModalOpen = false;

    openPopup() {
        this.open = true;
    }

    cancelConsultation() {
        this.$emit('update:status', ConsultationStatus.CanceledByAdministrator);
    }

    askToCancelConsultation() {
        this.confirmCancelModalOpen = true;
    }


    closeCancelModal() {
        this.confirmCancelModalOpen = false;
    }
}
